import * as qs from "query-string";
import {useDispatch} from "react-redux";
import {loggedIn, loggedOut} from "../../../store/ducks/auth";
import {useHistory} from "react-router-dom";
import {useEffect} from "react";

export function HandleLogin() {
  const dispatch = useDispatch();
  const history = useHistory();

  useEffect(() => {
    const logOut = !!qs.parse(window.location.search)["loggedOut"];

    if (logOut) {
      dispatch(loggedOut());
    }
    else {
      const token = qs.parse(window.location.search)["token"] as string;
      dispatch(loggedIn(token))
    }

    const returnTo = qs.parse(window.location.search)["returnTo"] as string | null;

    history.push(returnTo || "/");
  }, [dispatch, history])

  return (<></>)
}
